import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '~/store';
import { oneBoxV2Api } from '~/api/oneBoxV2';

export const getterNotifyImage = createSelector(
  [
    (state: RootState) => state.notify.images,
    (state: RootState) =>
      oneBoxV2Api.endpoints.getNotificationImages.select()(state)?.data,
  ],
  (initialData, imageData) => {
    if (imageData && imageData.data && imageData.data.length > 0) {
      return imageData.data;
    }
    return initialData;
  },
);

export const getterNotifyMessages = createSelector(
  [
    (state: RootState) => state.notify.messages,
    (state: RootState) =>
      oneBoxV2Api.endpoints.getNotificationMessages.select()(state)?.data,
  ],
  (initialData, messageData) => {
    if (messageData && messageData.data && messageData.data.length > 0) {
      return messageData.data;
    }
    return initialData;
  },
);

export const getterSemesters = createSelector(
  [
    (state: RootState) => state.notify.semesters,
    (state: RootState) =>
      oneBoxV2Api.endpoints.getSemesters.select()(state)?.data,
  ],
  (initialData, messageData) => {
    if (messageData && messageData.data && messageData.data.length > 0) {
      return messageData.data;
    }
    return initialData;
  },
);
